import axios from 'axios'
import router from '@/router'

const fetchOrgDetails = async ({ commit, rootState, dispatch }, orgId) => {
  await axios.get(`${rootState.baseURL}/orgs/${orgId}`)
    .then((res) => {
      if (res) {
        commit('setOrgData', res.data.data)
      }
    })
}
const editOrgDetails = async ({ commit, rootState, dispatch }, payload) => {
  await axios.put(`${rootState.baseURL}/orgs/${payload.id}`, payload)
    .then((res) => {
      if (res) {
        const payload = { type: 'success', text: res.data.detail }
        dispatch('updateMessages', payload, { root: true })
        commit('setOrgData', res.data.data)
      }
    })
}

const createOrg = async ({ commit, rootState, dispatch }, payload) => {
  await axios.post(`${rootState.baseURL}/orgs/`)
    .then(res => {
      const payload = { type: 'success', text: 'Successfully created organization' }
      dispatch('updateMessages', payload, { root: true })
      router.push({ path: `/organizations/${res.data.data.id}` })
    })
}

const deleteOrg = async ({ commit, rootState, dispatch }, payload) => {
  await axios.delete(`${rootState.baseURL}/orgs/${payload}`)
    .then((res) => {
      if (res) {
        const payload = { type: 'success', text: 'Successfully deleted organization' }
        router.push({ path: '/organizations/' })
        dispatch('updateMessages', payload, { root: true })
      }
    })
}

const removeUserFromOrg = async ({ commit, rootState, dispatch }, payload) => {
  await axios.delete(`${rootState.baseURL}/orgs/user/${payload.userId}`, { data: { organizations: [payload.orgId] } })
    .then(res => {
      if (res) {
        const toastPayload = { type: 'success', text: 'Successfully removed user from organization' }
        dispatch('updateMessages', toastPayload, { root: true })
      }
    })
}

const fetchOrgForNewUser = ({ rootState, commit, dispatch }, orgId) => {
  return new Promise((resolve, reject) => (
    axios.get(`${rootState.baseURL}/orgs/${orgId}`)
      .then((res) => { commit('setOrgData', res.data.data); return res })
      .then(resolve)
  ))
}

const inviteUser = ({ rootState, commit, dispatch }, payload) => {
  return axios.post(`${rootState.baseURL}/orgs/${payload.orgUser.orgId}/invite`, payload)
}

const createNewOrg = ({ rootState, dispatch }, payload) => {
  return new Promise((resolve, reject) => (
    axios.post(`${rootState.baseURL}/billing/organization/new`, payload)
    .then((res) => {
      if (res) {
        const toastPayload = { type: 'success', text: `Successfully added organization id: ${res.data.data.orgID}` }
        dispatch('updateMessages', toastPayload, { root: true })
      }
    })
    .then(resolve)
  ))
}

const fetchOrgFlags = ({ rootState, commit, dispatch }, payload) => {
  const uninterceptedAxiosInstance = axios.create({ headers: { Authorization: rootState.userToken } })
  return uninterceptedAxiosInstance.get(`${rootState.baseURL}/orgflag/${payload.orgId}`)
      .then((res) => {
        if (res) {
          commit('setOrgFlags', res.data.data.listOfFeatures)
        }
      }).catch(() => {
        // Don't need to do anything here, just catch the error
      }).finally(() => {
        commit('setOrgFlagsFetched', true)
      })
}

const fetchOrgFeatureEligibility = ({ rootState, commit }, payload) => {
  const uninterceptedAxiosInstance = axios.create({ headers: { Authorization: rootState.userToken } })
  return uninterceptedAxiosInstance.get(`${rootState.baseURL}/eligibility/org/${payload.orgId}/feature/${payload.feature}`)
      .then((res) => {
        if (res) {
          commit('updateOrgFeatures', res.data.data)
        }
      })
      .catch(() => {})
      .finally(() => {
        commit('setOrgFeaturesFetched', true)
      })
}

const toggleFlagForOrg = async ({ rootState, commit, dispatch }, payload) => {
  await axios.put(`${rootState.baseURL}/orgflag/${payload.orgId}/toggle`, { name: payload.name, optIn: payload.optIn })
    .then((res) => {
      if (res) {
        commit('setOrgFlags', [res.data.data])
      }
    })
  }

const resendInvite = ({ rootState }, payload) => {
  return axios.post(`${rootState.baseURL}/orgs/${payload.orgUser.orgId}/resendInvite`, payload)
}

export default {
  inviteUser,
  removeUserFromOrg,
  fetchOrgDetails,
  createOrg,
  fetchOrgForNewUser,
  editOrgDetails,
  deleteOrg,
  createNewOrg,
  fetchOrgFlags,
  fetchOrgFeatureEligibility,
  toggleFlagForOrg,
  resendInvite,
}
